import {
  Avatar,
  Box,
  Button,
  Chip,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  TablePagination,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { AccountCircle, History } from "@material-ui/icons";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import BatteryAlertIcon from "@material-ui/icons/BatteryAlert";
import BatteryChargingFullIcon from "@material-ui/icons/BatteryChargingFull";
import InfoIcon from "@material-ui/icons/Info";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import MapIcon from "@material-ui/icons/Map";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import TimelineIcon from "@material-ui/icons/Timeline";
import VisibilityIcon from "@material-ui/icons/Visibility";
import WifiIcon from "@material-ui/icons/Wifi";
import WifiOffIcon from "@material-ui/icons/WifiOff";
import { isArray } from "lodash";
import moment from "moment";
import { useCallback, useMemo, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AddressAction } from "../../actions/Address";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";
import {
  convertSecondsToHM,
  formatDistance,
  formatHours,
  formatSpeed,
} from "./formatter";
import { Tooltip } from "@material-ui/core";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import CloseIcon from "@material-ui/icons/Close";
// Import react-window for virtualization
import { FixedSizeList as List } from "react-window";
import { Dialog, IconButton } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { BiTrip } from "react-icons/bi";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddressCell from "./FetchAdrresWithCopy";
import CommanCardDeatils from "./CardShowDeatils.js/CommanCard";
const useStyles = makeStyles((theme) => ({
  tooltip: {
    marginTop: "-60px !important",
    backgroundColor: "#003a6b",
    fontSize: "14px", // Increased from 12px
    fontWeight: "500", // Added medium font weight
    maxWidth: 400,
    textAlign: "center",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    color: "#ffffff", // Explicit white color
    lineHeight: "1.4", // Better line spacing
    padding: "12px 16px", // Increased padding
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)", // Added shadow for better separation
    border: "1px solid rgba(255,255,255,0.1)", // Subtle border
  },
  remarkText: {
    display: "inline-block",
    cursor: "pointer",
    maxWidth: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    padding: "2px 4px",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "rgba(0, 58, 107, 0.1)",
    },
  },
  root: {
    width: "100%",
    height: "auto",
  },
  tableWrapper: {
    borderRadius: "4px",
    overflow: "hidden",
  },
  tableContainer: {
    maxHeight: "80vh",
    overflow: "auto",
    position: "relative",
  },
  virtualTableContainer: {
    height: 600,
    overflow: "auto",
    position: "relative",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 650,
  },
  virtualTable: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: 650,
    tableLayout: "fixed",
  },
  stickyHeaderRow: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "#003a6b",
  },
  headerCell: {
    backgroundColor: "#003a6b",
    color: "#fff",
    fontWeight: "bold",
    padding: "16px",
    whiteSpace: "nowrap",
    fontSize: "14px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    "&:last-child": {
      borderRight: "none",
    },
  },
  bodyRow: {
    transition: "all 0.2s ease",
    "&:nth-child(odd)": {
      backgroundColor: "#fafafa",
    },
    "&:hover": {
      backgroundColor: "#e3f2fd",
      transform: "translateY(-1px)",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    },
    cursor: "pointer",
  },
  bodyCell: {
    padding: "16px",
    maxWidth: "360px",
    fontSize: "14px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "&:last-child": {
      borderRight: "none",
    },
  },
  noDataRow: {
    textAlign: "center",
    padding: "32px",
    color: "#666",
    fontStyle: "italic",
  },
  paginationContainer: {
    backgroundColor: "#fafafa",
    borderTop: "1px solid #e0e0e0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    alignContent: "center",
    padding: "5px",
  },
  outlinedChip: {
    margin: theme.spacing(0.5),
    borderRadius: 20,
    borderColor: "#667eea",
    color: "#667eea",
    fontWeight: 500,
    transition: "all 0.3s ease",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
      transform: "scale(1.05)",
    },
  },
  statusChip: {
    borderRadius: 20,
    fontWeight: 600,
    textTransform: "uppercase",
    fontSize: "0.75rem",
    letterSpacing: "0.05em",
  },
  activeChip: {
    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    color: "white",
  },
  inactiveChip: {
    background: "linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)",
    color: "white",
  },
  virtualRow: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #e0e0e0",
    "&:nth-child(odd)": {
      backgroundColor: "#fafafa",
    },
    "&:hover": {
      backgroundColor: "#e3f2fd",
    },
  },
  virtualCell: {
    padding: "16px",
    fontSize: "14px",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
    minWidth: 0,
  },
}));

const getIconFromMap = (iconName) => {
  const iconMap = {
    LocationOnIcon: <LocationOnIcon />,
    InfoIcon: <InfoIcon />,
    MapIcon: <MapIcon />,
    AddCircleIcon: <AddCircleIcon />,
    VisibilityIcon: <VisibilityIcon />,
    NotificationsActiveIcon: <NotificationsActiveIcon />,
    TimelineIcon: <TimelineIcon />,
    NoteAddIcon: <NoteAddIcon />,
    FileCopyIcon: <FileCopyIcon />,
    BiTrip: <BiTrip style={{ fontSize: "25px" }} />,
    HighlightOffIcon: <HighlightOffIcon />,
    CheckCircleIcon: <CheckCircleIcon />,
    History: <History />,
  };
  return iconMap[iconName] || null;
};
const STATUS_DISPLAY_MAP = {
  INVALID: "UNDESIGNATED",
  COMPLETED: "DESIGNATED",
};

const CommonTable = ({
  headers = [],
  rows = [],
  totalPages,
  pageNo,
  setPageNo,
  pageSize,
  setPageSize,
  setBool,
  updateRowData,
  setModal = false,
  isShowPagination = true,
  rportType,
  userlisttype,
  applyvertualization = false,
  onVehicleCountClick,
  vehicleNumber,
  selectedNit,
  isShowCounte = false,
  dataList = [],
}) => {
  const { showSnackbar } = useSnackbar();
  const classes = useStyles();
  const navigate = useNavigate();
  const tableContainerRef = useRef();
  const [columnWidths, setColumnWidths] = useState([]);
  const [imagePreview, setImagePreview] = useState({ open: false, url: "" });
  const [sortState, setSortState] = useState({ column: null, isAsc: false });
  const [multipleFilesPreview, setMultipleFilesPreview] = useState({
    open: false,
    files: [],
  });

  const handleImagePreviewOpen = (imageUrl) => {
    setImagePreview({ open: true, url: imageUrl });
  };

  const handleImagePreviewClose = () => {
    setImagePreview({ open: false, url: "" });
  };

  useEffect(() => {
    if (applyvertualization && headers.length > 0) {
      const widths = headers.map((header) => {
        const baseWidth = 250;
        const contentWidth = header.name.length * 8 + 32;
        return Math.max(baseWidth, contentWidth);
      });
      setColumnWidths(widths);
    }
  }, [headers, applyvertualization]);

  const handleChangePage = useCallback(
    (_, newPage) => {
      setPageNo(newPage);
      setBool(true);
    },
    [setPageNo, setBool],
  );

  const handleChangeRowsPerPage = useCallback(
    (event) => {
      const newSize = parseInt(event.target.value, 10);
      setPageSize(newSize);
      setPageNo(0);
      setBool(true);
    },
    [setPageSize, setPageNo, setBool],
  );

  const sortingHAndler = (type) => {
    // Determine new direction: if same column, flip it; if new column, start ascending
    const newIsAsc = sortState.column === type ? !sortState.isAsc : true;
    setSortState({ column: type, isAsc: newIsAsc });

    if (type === "opration") {
      const sortData = [...rows].sort((a, b) =>
        newIsAsc
          ? new Date(a?.timestamp) - new Date(b?.timestamp)
          : new Date(b?.timestamp) - new Date(a?.timestamp),
      );
      if (updateRowData) updateRowData(sortData);
    } else if (type === "vehicle") {
      const sortData = [...rows].sort((a, b) =>
        newIsAsc
          ? new Date(a?.lastPollingDate) - new Date(b?.lastPollingDate)
          : new Date(b?.lastPollingDate) - new Date(a?.lastPollingDate),
      );
      if (updateRowData) updateRowData(sortData);
    } else if (type === "nitNo") {
      const sortData = [...rows].sort((a, b) => {
        const valA = (a?.nitNo || "").toString().trim();
        const valB = (b?.nitNo || "").toString().trim();
        return newIsAsc
          ? valA.localeCompare(valB, undefined, {
              numeric: true,
              sensitivity: "base",
            })
          : valB.localeCompare(valA, undefined, {
              numeric: true,
              sensitivity: "base",
            });
      });
      if (updateRowData) updateRowData(sortData);
    } else if (type === "nitTypeOfContract") {
      const sortData = [...rows].sort((a, b) => {
        const valA = (a?.nitTypeOfContract || "").toString().trim();
        const valB = (b?.nitTypeOfContract || "").toString().trim();
        return newIsAsc
          ? valA.localeCompare(valB, undefined, { sensitivity: "base" })
          : valB.localeCompare(valA, undefined, { sensitivity: "base" });
      });
      if (updateRowData) updateRowData(sortData);
    } else if (type === "mineName") {
      const sortData = [...rows].sort((a, b) => {
        const valA = (a?.mineName || "").toString().trim();
        const valB = (b?.mineName || "").toString().trim();
        return newIsAsc
          ? valA.localeCompare(valB, undefined, { sensitivity: "base" })
          : valB.localeCompare(valA, undefined, { sensitivity: "base" });
      });
      if (updateRowData) updateRowData(sortData);
    } else if (type === "vendorName") {
      const sortData = [...rows].sort((a, b) => {
        const valA = (a?.vendorName || "").toString().trim();
        const valB = (b?.vendorName || "").toString().trim();
        return newIsAsc
          ? valA.localeCompare(valB, undefined, { sensitivity: "base" })
          : valB.localeCompare(valA, undefined, { sensitivity: "base" });
      });
      if (updateRowData) updateRowData(sortData);
    } else if (type === "officialName") {
      const sortData = [...rows].sort((a, b) => {
        const valA = (a?.officialName || "").toString().trim();
        const valB = (b?.officialName || "").toString().trim();
        return newIsAsc
          ? valA.localeCompare(valB, undefined, { sensitivity: "base" })
          : valB.localeCompare(valA, undefined, { sensitivity: "base" });
      });
      if (updateRowData) updateRowData(sortData);
    }
  };

  const fetchAddress = useCallback(
    async (lat, lng, index, keyType, keyName) => {
      try {
        const res = await AddressAction.ConvertLatTngToAddress(
          lat,
          lng,
          showSnackbar,
        );
        if (res?.responseCode === 500 || res?.responseCode === 204) return;
        const address = res?.add || "Address not found";
        if (rportType) {
          updateRowData((prev) => ({
            ...prev,
            [rportType]: prev[rportType].map((item, i) =>
              i === index ? { ...item, [keyName]: address } : item,
            ),
          }));
        } else {
          updateRowData((prev) =>
            prev?.map((item, i) =>
              i === index ? { ...item, [keyType]: address } : item,
            ),
          );
        }
      } catch (error) {
        console.error("Error fetching address:", error);
      }
    },
    [updateRowData, rportType],
  );

  const redairectValue = useCallback(
    (row, header) => {
      if (!header) return;

      const {
        isTripTrack,
        url,
        type,
        newTab,
        isModal,
        isClickHandler,
        onClickHandler,
        isView = true,
        passURLSearchParams,
        passURLSearchParams2,
        passURLSearchParams3,
        passURLSearchParams4,
        createdByCheck,
        loggedInUserId,
        urlKey,
      } = header;

      const isOwnerMatched = createdByCheck
        ? loggedInUserId === row?.createdBy
        : true;

      if (!isOwnerMatched) return;

      if (isClickHandler && typeof onClickHandler === "function") {
        onClickHandler(row, header);
        return;
      }

      if (isTripTrack && isView) {
        if (isTripTrack) {
          const payload = {
            fromdate: row?.startTime,
            LoadingPoint: row?.sourcePointId,
          };
          localStorage.setItem("liveTracking", JSON.stringify(payload));
        }
        const path = ["COMPLETED", "INVALID"].includes(row?.tripStatus)
          ? `/tripTrack/${row?.tripId}`
          : `/live/${row?.vehicleId}`;

        return window.open(path, "_blank");
      }

      if (url && isView && url === "sitehistory") {
        const dynamicId = row?.id; // Use site ID
        const path = `/${url}/${dynamicId}`;
        return newTab ? window.open(path, "_blank") : navigate(path);
      }

      if (url && isView) {
        const dynamicId = header?.urlKey ? row?.[header.urlKey] : row?.id;
        const encodedId = encodeURIComponent(dynamicId);

        const path =
          type === "view"
            ? header.isUnauthorized
              ? `/${url}/${encodedId}/${row?.registeredUser}`
              : header.selectedNit && selectedNit
                ? `/${url}/${encodedId}?NitId=${selectedNit?.id}`
                : `/${url}/${encodedId}`
            : `/${url}`;

        return newTab ? window.open(path, "_blank") : navigate(path);
      }

      if (isModal) {
        return setModal(true);
      }

      if (passURLSearchParams) {
        const path = `/${url}?${passURLSearchParams}=${row?.mineId || ""}&${passURLSearchParams2}=${row?.vendorId || ""}&${passURLSearchParams3}=${row?.mineName || ""}&${passURLSearchParams4}=${row?.vendorName || ""}`;
        return newTab ? window.open(path, "_blank") : navigate(path);
      }
    },
    [navigate, selectedNit],
  );

  const getNestedValue = useCallback((obj, path) => {
    return path?.split(".")?.reduce((acc, key) => acc?.[key], obj);
  }, []);

  const renderDetailsBlock = useCallback(
    (row, detailConfig, header) => {
      const data = getNestedValue(row, header?.keyName);
      const value = header?.isObjectValue ? data : row;

      if (header?.isTransporterNameFormat && header?.showAllDeatails) {
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "14px",
              color: header?.color,
              lineHeight: "1.4",
            }}
            onClick={() => redairectValue(row, header)}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {header.showAllDeatails
                .map((detail, idx) => {
                  let displayValue = "N/A";
                  let label = detail.label || detail.name;

                  if (detail.name && value?.[detail.name]) {
                    displayValue = value[detail.name];
                  }

                  if (!displayValue || displayValue === "N/A") {
                    displayValue = "N/A";
                  }

                  return (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 600,
                          minWidth: "100px",
                          color: header?.color || "#555",
                          fontSize: "12px",
                        }}
                      >
                        {label}:
                      </span>
                      <span
                        style={{
                          color: header?.color || "#333",
                          wordBreak: "break-word",
                        }}
                      >
                        {displayValue}
                      </span>
                    </div>
                  );
                })
                .filter(Boolean)}
            </div>
          </div>
        );
      }

      const name = value?.[detailConfig?.name] ?? "N/A";
      const lastname = value?.[detailConfig?.lastname] ?? "";
      const code = value?.[detailConfig?.code]
        ? `(${value?.[detailConfig?.code]})`
        : "";
      const image = value?.[detailConfig?.image];
      let cleanUrl = "";

      // if (image) {
      //   cleanUrl = image.replace("/downloadFile?fileName=", "");
      // }
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {header?.showImage &&
            (image ? (
              <img
                src={image}
                alt="user"
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: "50%",
                  border: "1px solid grey",
                }}
              />
            ) : (
              <AccountCircle style={{ fontSize: 28 }} />
            ))}
          <span>{`${name} ${lastname} ${code}`}</span>
        </div>
      );
    },
    [getNestedValue, redairectValue],
  );

  const renderStrategies = useMemo(
    () => ({
      expandableImage: (row, header) => {
        const value = getNestedValue(row, header.keyName);

        if (!value) {
          return "--";
        }

        const fileUrls =
          typeof value === "string"
            ? value.split(",").filter((url) => url.trim() !== "")
            : Array.isArray(value)
              ? value
              : [];

        if (fileUrls.length === 0) {
          return "--";
        }

        if (fileUrls.length === 1) {
          return renderSingleFile(fileUrls[0]);
        }

        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              maxWidth: "300px",
            }}
          >
            {fileUrls.slice(0, 1).map((fileUrl, index) => (
              <div key={index} style={{ position: "relative" }}>
                {renderSingleFile(fileUrl, index)}
                {index === 0 && fileUrls.length > 1 && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.7)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenMultipleFilesPreview(fileUrls);
                    }}
                  >
                    <Typography
                      variant="body2"
                      style={{ color: "white", fontWeight: "bold" }}
                    >
                      +{fileUrls.length - 1}
                    </Typography>
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      },

      sNo: (_, __, index) => index + 1 + pageNo * pageSize,

      isDetails: (row, header) => {
        const detailConfig = header?.showAllDeatails?.[0];
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
            onClick={() => redairectValue(row, header)}
          >
            {renderDetailsBlock(row, detailConfig, header)}
          </div>
        );
      },

      isVendorDetails: (row, header) => {
        const handleNameClick = (vendor) => {
          const path = `/transporterlist?NitId=${row?.id}&vendorName=${vendor?.name}`;
          return header.newTab ? window.open(path, "_blank") : navigate(path);
        };

        const handleVehicleCountClick = (vendor) => {
          const path = `/vehiclelist?NitId=${row?.id}&vendor=${vendor?.id}`;
          return header.newTab ? window.open(path, "_blank") : navigate(path);
        };

        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              maxWidth: "400px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                flexWrap: "wrap",
              }}
            >
              {row.vendorDTOV2.length === 0 && <span>N/A</span>}

              {row.vendorDTOV2?.map((vendor, index) => (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <span
                    onClick={() => handleNameClick(vendor)}
                    style={{
                      cursor: "pointer",
                      color: "rgb(20, 146, 230)",
                      marginRight: 4,
                    }}
                  >
                    {vendor.name}
                  </span>

                  <span
                    onClick={() => handleVehicleCountClick(vendor)}
                    style={{
                      cursor: "pointer",
                      color: "rgba(27, 230, 20, 1)",
                      fontWeight: "bold",
                    }}
                  >
                    ({vendor.vehicleCount})
                  </span>

                  {index < row.vendorDTOV2.length - 1 && (
                    <span
                      style={{
                        color: "rgb(20, 146, 230)",
                      }}
                    >
                      ,
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      },
      isOnclick: (row, header) => {
        const value = getNestedValue(row, header.keyName);

        const resolveColor = () => {
          if (row.status === "IN_PROGRESS") return "black";
          if (header?.createdByCheck) {
            return header?.loggedInUserId === row?.createdBy
              ? header?.color
              : "black";
          }
          return header?.color;
        };

        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: resolveColor(),
            }}
            onClick={() => redairectValue(row, header)}
          >
            <span>{header?.isIcon ? getIconFromMap(header?.isIcon) : ""}</span>{" "}
            {value ?? ""}
          </div>
        );
      },
      iconList: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
            }}
          >
            {header?.isIconList.map((val) => {
              return (
                <span
                  key={val.icon}
                  style={{
                    cursor: "pointer",
                    fontSize: "17px",
                    color:
                      // val.isRemark && getNestedValue(row, val?.keyName)
                      // ? "green"
                      // :

                      val?.color,
                  }}
                  onClick={() => redairectValue(row, val)}
                >
                  <span>{val?.icon ? getIconFromMap(val?.icon) : ""}</span>{" "}
                  {value ?? ""}
                </span>
              );
            })}
          </div>
        );
      },
      isDate: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  lineHeight: "1.4",
                }}
              >
                {/* Last Updated Date */}
                <span style={{ fontWeight: 500 }}>
                  {moment(value).format(
                    header.isSeconde
                      ? "DD-MM-YYYY HH:mm:ss"
                      : header.isNoTime
                        ? "DD-MM-YYYY"
                        : "DD-MM-YYYY HH:mm",
                  )}
                </span>

                {/* Since Time */}
                {header.isStopSince && (
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      fontWeight: "bold",
                    }}
                  >
                    ⏱ Since:{" "}
                    {(() => {
                      const d = moment.duration(moment().diff(moment(value)));
                      return `${Math.floor(d.asDays())}d ${moment
                        .utc(d.asMilliseconds())
                        .format("HH:mm:ss")}`;
                    })()}
                  </span>
                )}
              </div>
            ) : (
              "---"
            )}
          </div>
        );
      },
      isDistance: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? formatDistance(Math.abs(parseFloat(value)), "km") : "---"}
          </div>
        );
      },
      isVehicleNumber: (row, header) => {
        return <div>{vehicleNumber ? vehicleNumber : "---"}</div>;
      },
      isDistanceValue: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value
              ? `${parseFloat(value)?.toFixed(2)} km`
              : value === 0
                ? "0 km"
                : "---"}
          </div>
        );
      },

      isLoadStatus: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? value : "NO_DATA"}
          </div>
        );
      },

      isSeconde: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? convertSecondsToHM(value) : "0 Hr 0 Min"}
          </div>
        );
      },

      isFormatHours: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? formatHours(value) : "0 Hr 0 Min"}
          </div>
        );
      },
      isSpeed: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? formatSpeed(value, "kmh") : "--"}
          </div>
        );
      },
      isIgnition: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <div
            style={{
              cursor: "pointer",
              fontSize: "17px",
              color: header?.color,
            }}
          >
            {value ? (value === true ? "ON" : "OFF") : "--"}
          </div>
        );
      },

      isOnline: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {value === "online" || value === "ON" ? (
              <WifiIcon style={{ color: "#4caf50" }} />
            ) : value === "offline" || value === "OFF" ? (
              <WifiOffIcon style={{ color: "#f44336" }} />
            ) : (
              ""
            )}
            {value ?? "--"}
          </span>
        );
      },
      isLoopShowName: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        const displayValue = Array.isArray(value)
          ? value
              .map((item) => (typeof item === "object" ? item?.name : item))
              .filter(Boolean)
              .join(", ") || "--"
          : "--";

        if (displayValue && displayValue.length > 40) {
          const truncatedValue =
            displayValue.length > 40
              ? displayValue.substring(0, 40) + "..."
              : displayValue;

          return (
            <Tooltip
              title={displayValue}
              arrow
              placement="bottom"
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -10],
                    },
                  },
                ],
              }}
              classes={{
                tooltip: classes.tooltip,
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                {truncatedValue}
              </span>
            </Tooltip>
          );
        }

        return displayValue;
      },
      isLoopShowName2: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        const displayValue = Array.isArray(value)
          ? value
              .map((item) => (typeof item === "object" ? item?.name : item))
              .filter(Boolean)
              .join(", ") || "--"
          : "N/A";

        if (displayValue && displayValue.length > 40) {
          const truncatedValue =
            displayValue.length > 40
              ? displayValue.substring(0, 40) + "..."
              : displayValue;

          return (
            <Tooltip
              title={displayValue}
              arrow
              placement="bottom"
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -10],
                    },
                  },
                ],
              }}
              classes={{
                tooltip: classes.tooltip,
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                {truncatedValue}
              </span>
            </Tooltip>
          );
        }

        return displayValue;
      },
      isAddress: (row, header, index) => {
        return (
          <AddressCell
            row={row}
            header={header}
            index={index}
            fetchAddress={fetchAddress}
            classes={classes}
            getNestedValue={getNestedValue}
            getIconFromMap={getIconFromMap}
          />
        );
      },

      locationInfo: (row, header, index) => {
        const value = getNestedValue(row, header.keyName);
        const address =
          row?.address ||
          `${row?.latitude ?? "--"} , ${row?.longitude ?? "--"}`;
        return (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              cursor: "pointer",
            }}
          >
            {value ? value : address}
          </span>
        );
      },

      isActive: (row, header, index) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <Chip
            label={value ? "Active" : "IN Active"}
            className={`${classes.statusChip} ${
              value ? classes.activeChip : classes.inactiveChip
            }`}
            size="small"
          />
        );
      },
      isUserType: (row, header, index) => {
        const value = getNestedValue(row, header.keyName);
        return value ? "Existing User" : "Manual User";
      },

      isPower: (row, header, index) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {value ? (
              <BatteryChargingFullIcon style={{ color: "#4caf50" }} />
            ) : value === false ? (
              <BatteryAlertIcon style={{ color: "#f44336" }} />
            ) : (
              "--"
            )}
          </span>
        );
      },

      isStatus: (row, header, index) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {value ? (
              <WifiIcon style={{ color: "#4caf50" }} />
            ) : value === false ? (
              <WifiOffIcon style={{ color: "#f44336" }} />
            ) : (
              <WifiOffIcon style={{ color: "#f44336" }} />
            )}
          </span>
        );
      },
      isBooleanValue: (row, header, index) => {
        const value = getNestedValue(row, header.keyName);
        return value ? "Yes" : "No";
      },

      isRemarks: (row, header) => {
        const value = header.isNestedObject
          ? getNestedValue(row, header.keyName)
          : row[header.keyName];

        if (!value || value === "" || value === null || value === undefined) {
          return "--";
        }

        const limitLength = header.limitLength || 20;
        const displayValue =
          value.length > limitLength
            ? value.substring(0, limitLength) + "..."
            : value;

        // Show tooltip only if content is truncated
        if (value.length > limitLength) {
          return (
            <Tooltip
              title={
                <div
                  style={{
                    maxWidth: "320px",
                    padding: "4px",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    lineHeight: "1.5",
                  }}
                >
                  {value}
                </div>
              }
              arrow
              placement="top"
              classes={{
                tooltip: classes.tooltip,
              }}
            >
              <span className={classes.remarkText}>{displayValue}</span>
            </Tooltip>
          );
        }

        return value;
      },

      isBox: (row, header) => {
        const rawValue = getNestedValue(row, header.keyName);

        const value =
          STATUS_DISPLAY_MAP[
            typeof rawValue === "string"
              ? rawValue.trim().toUpperCase()
              : rawValue
          ] || rawValue;

        // Color is driven by the RAW status so COMPLETED still turns green
        return (
          <span
            style={{
              backgroundColor:
                rawValue === "RUNNING" || rawValue === "COMPLETED"
                  ? "#4CAF50"
                  : rawValue === "IN_PROGRESS"
                    ? "#fae571ff"
                    : rawValue === "OFFLINE"
                      ? "rgb(19 19 245)"
                      : rawValue === "IDLE"
                        ? "rgb(247, 214, 31)"
                        : rawValue === "STOP"
                          ? "rgba(194, 19, 19, 0.74)"
                          : "rgb(214 25 58)",
              color: rawValue === "IN_PROGRESS" ? "black" : "#FFF",
              borderRadius: "6px",
              padding: "2px 7px",
              display: "inline-block",
              fontWeight: 600,
              maxWidth: "130px",
              minWidth: "100px",
              textAlign: "center",
            }}
          >
            {value ? value : "---"}
          </span>
        );
      },
      isVehicleCount: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        return (
          <span
            style={{
              color: "#1976d2",
              cursor: "pointer",
              // textDecoration: "underline",
              fontWeight: "bold",
            }}
            onClick={() => onVehicleCountClick(row, header)}
          >
            {value ?? "0"}
          </span>
        );
      },
      isratio: (row, header) => {
        const value1 = getNestedValue(row, header.keyName);
        const value2 = getNestedValue(row, header.keyName2);

        let percentage = null;
        if (!isNaN(value1) && !isNaN(value2) && parseFloat(value1) > 0) {
          percentage = (parseFloat(value2) / parseFloat(value1)) * 100;
        }

        let backgroundColor = "gray";
        if (percentage !== null) {
          backgroundColor = percentage >= 90 ? "#4CAF50" : "#f44336";
        }

        return (
          <span
            style={{
              backgroundColor: backgroundColor,
              color: "#FFF",
              borderRadius: "6px",
              padding: "2px 7px",
              display: "inline-block",
              fontWeight: 600,
              maxWidth: "120px",
              minWidth: "100px",
              textAlign: "center",
            }}
          >
            {value1 !== undefined && value2 !== undefined
              ? `${value2} / ${value1}`
              : "-/-"}
          </span>
        );
      },

      showsiteCategory: (row, header) => {
        const value = getNestedValue(row, header.keyName);
        const value2 = getNestedValue(row, header.keyName2);

        return (
          <div>{value ? (value2 ? `${value} (${value2})` : value) : "---"}</div>
        );
      },
    }),
    [
      pageNo,
      pageSize,
      getNestedValue,
      redairectValue,
      renderDetailsBlock,
      fetchAddress,
      classes,
      onVehicleCountClick,
      selectedNit,
    ],
  );

  const renderSingleFile = (fileUrl, index = 0) => {
    const getFileType = (fileUrl) => {
      if (!fileUrl) return "unknown";
      const extension = fileUrl.split(".").pop()?.toLowerCase();
      if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) {
        return "image";
      } else if (extension === "pdf") {
        return "pdf";
      } else if (["xlsx", "xls", "csv"].includes(extension)) {
        return "excel";
      }
      return "unknown";
    };

    const fileType = getFileType(fileUrl);

    return (
      <div
        style={{
          width: "60px",
          height: "60px",
          border: "1px solid #ddd",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          background: "#f5f5f5",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.stopPropagation();
          if (fileType === "image") {
            handleImagePreviewOpen(fileUrl);
          } else {
            window.open(fileUrl, "_blank");
          }
        }}
      >
        {fileType === "image" ? (
          <img
            src={fileUrl}
            alt={`File ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : fileType === "pdf" ? (
          <div style={{ textAlign: "center", padding: "4px" }}>
            <div style={{ fontSize: "18px", marginBottom: "2px" }}>📄</div>
            <div style={{ fontSize: "8px", color: "#666" }}>PDF</div>
          </div>
        ) : fileType === "excel" ? (
          <div style={{ textAlign: "center", padding: "4px" }}>
            <div style={{ fontSize: "18px", marginBottom: "2px" }}>📊</div>
            <div style={{ fontSize: "8px", color: "#666" }}>Excel</div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "4px" }}>
            <div style={{ fontSize: "18px", marginBottom: "2px" }}>📎</div>
            <div style={{ fontSize: "8px", color: "#666" }}>File</div>
          </div>
        )}
      </div>
    );
  };

  // Add handler for multiple files preview
  const handleOpenMultipleFilesPreview = (files) => {
    setMultipleFilesPreview({ open: true, files });
  };

  const handleCloseMultipleFilesPreview = () => {
    setMultipleFilesPreview({ open: false, files: [] });
  };

  const renderCellContent = useCallback(
    (row, header, index) => {
      if (header.keyName === "sNo")
        return renderStrategies.sNo(row, header, index);
      if (header.keyName === "locationInfo")
        return renderStrategies.locationInfo(row, header, index);

      for (const key in renderStrategies) {
        if (header[key]) return renderStrategies[key](row, header, index);
      }

      // let value = getNestedValue(row, header?.keyName) ?? "N/A";
      let value = getNestedValue(row, header?.keyName);

      if (header?.keyName?.startsWith("distanceRanges.")) {
        value = value ?? 0;
      } else {
        value = value ?? "N/A";
      }
      if (
        (header.keyName === "sites" ||
          header.keyName === "notificationType" ||
          header.keyName === "hex" ||
          header.keyName === "packet") &&
        value &&
        value.length > 40
      ) {
        const displayValue =
          value.length > 40 ? value.substring(0, 40) + "..." : value;

        return (
          <Tooltip
            title={value}
            arrow
            placement="bottom"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -10],
                  },
                },
              ],
            }}
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <span
              style={{
                display: "inline-block",
                cursor: "pointer",
                width: "100%",
              }}
            >
              {displayValue}
            </span>
          </Tooltip>
        );
      }

      if (header.keyName === "NoOfUsers") {
        const displayValue = value.count;
        const tooltipvalue = value.UsersName.join(", ");
        return (
          <Tooltip
            title={tooltipvalue}
            arrow
            placement="bottom"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -10],
                  },
                },
              ],
            }}
            classes={{
              tooltip: classes.tooltip,
            }}
          >
            <span
              style={{
                display: "inline-block",
                cursor: "pointer",
                width: "100%",
              }}
            >
              {displayValue}
            </span>
          </Tooltip>
        );
      }

      if (header.limitLength && typeof value === "string") {
        const displayValue =
          value.length > header.limitLength
            ? value.substring(0, header.limitLength) + "..."
            : value;

        if (value.length > header.limitLength) {
          return (
            <Tooltip
              title={value}
              arrow
              placement="bottom"
              classes={{ tooltip: classes.tooltip }}
            >
              <span
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                  width: "100%",
                }}
              >
                {displayValue}
              </span>
            </Tooltip>
          );
        }

        return displayValue;
      }

      return value;
    },
    [renderStrategies, getNestedValue, selectedNit],
  );
  const visibleHeaders = useMemo(
    () => headers.filter((h) => h?.isShow !== false),
    [headers],
  );

  // Virtualized Row Component
  const VirtualizedRow = ({ index, style }) => {
    const row = rows[index];

    return (
      <div
        style={style}
        className={classes.virtualRow}
        onClick={() => {
          // You can add row click handling here if needed
        }}
      >
        {visibleHeaders.map((header, cellIndex) => (
          <div
            key={header.keyName}
            className={classes.virtualCell}
            style={{
              flex: columnWidths[cellIndex] || 1,
              minWidth: columnWidths[cellIndex] || 150,
            }}
          >
            {renderCellContent(row, header, index)}
          </div>
        ))}
      </div>
    );
  };

  // Calculate total width for virtualized table
  const totalWidth = useMemo(() => {
    return columnWidths.reduce((sum, width) => sum + width, 0);
  }, [columnWidths]);

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        {applyvertualization ? (
          // Virtualized Table
          <div
            className={classes.virtualTableContainer}
            ref={tableContainerRef}
          >
            {/* Header */}
            <div
              className={classes.stickyHeaderRow}
              style={{
                display: "flex",
                position: "sticky",
                top: 0,
                zIndex: 2,
              }}
            >
              {visibleHeaders.map((header, index) => (
                <div
                  key={header.keyName}
                  className={classes.headerCell}
                  style={{
                    flex: columnWidths[index] || 1,
                    minWidth: columnWidths[index] || 150,
                  }}
                >
                  {header.isSorting ? (
                    <spam>{header?.name} </spam>
                  ) : (
                    header?.name
                  )}
                </div>
              ))}
            </div>

            {/* Virtualized Body */}
            {rows && isArray(rows) && rows.length === 0 ? (
              <div className={classes.noDataRow}>No data available.</div>
            ) : (
              <List
                height={550} // Adjust based on your container height
                itemCount={rows.length}
                itemSize={60} // Approximate row height
                width={totalWidth || "100%"}
              >
                {VirtualizedRow}
              </List>
            )}
          </div>
        ) : (
          // Regular Table
          <div className={classes.tableContainer}>
            <table className={classes.table}>
              <thead>
                <tr className={classes.stickyHeaderRow}>
                  {visibleHeaders.map((header, ind) => (
                    <th key={ind} className={classes.headerCell}>
                      {header.isSorting ? (
                        <span>
                          {header?.name}{" "}
                          {sortState.column === header?.sortType &&
                          sortState.isAsc ? (
                            <ArrowDownwardIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => sortingHAndler(header?.sortType)}
                            />
                          ) : (
                            <ArrowUpwardIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => sortingHAndler(header?.sortType)}
                            />
                          )}
                        </span>
                      ) : (
                        header?.name
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows && isArray(rows) && rows?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={visibleHeaders.length}
                      className={classes.noDataRow}
                    >
                      No data available.
                    </td>
                  </tr>
                ) : (
                  rows &&
                  isArray(rows) &&
                  rows?.map((row, index) => (
                    <tr
                      key={row?.id ? row?.id : index}
                      className={classes.bodyRow}
                      style={{
                        background:
                          rportType === "movement"
                            ? row?.endTime
                              ? "#fdbdbd"
                              : "rgb(191, 245, 228)"
                            : row.alertPostion
                              ? "#ffa6a6"
                              : "",
                      }}
                    >
                      {visibleHeaders?.map((header) => (
                        <td key={header.keyName} className={classes.bodyCell}>
                          {renderCellContent(row, header, index)}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {isShowPagination !== false && (
        <Box className={classes.paginationContainer}>
          <Grid
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            {isShowCounte && <CommanCardDeatils detailList={dataList} />}
          </Grid>

          <Grid
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
              component="div"
              count={totalPages}
              rowsPerPage={pageSize}
              page={pageNo}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
              labelRowsPerPage="Rows per page:"
            />
          </Grid>
        </Box>
      )}

      <Dialog
        open={imagePreview.open}
        onClose={handleImagePreviewClose}
        maxWidth="md"
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "hidden",
          },
        }}
      >
        <div style={{ position: "relative" }}>
          <IconButton
            onClick={handleImagePreviewClose}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "white",
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={imagePreview.url}
            alt="Preview"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              display: "block",
              margin: "auto",
            }}
            onClick={handleImagePreviewClose}
          />
        </div>
      </Dialog>

      <Dialog
        open={multipleFilesPreview.open}
        onClose={handleCloseMultipleFilesPreview}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: "#003a6b" }}>
          <Typography style={{ color: "white" }}>
            Attached Files ({multipleFilesPreview.files.length})
          </Typography>
          <IconButton
            onClick={handleCloseMultipleFilesPreview}
            style={{ position: "absolute", right: 7, top: 7, color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
              gap: "16px",
              padding: "16px 0",
            }}
          >
            {multipleFilesPreview.files.map((fileUrl, index) => {
              const getFileType = (fileUrl) => {
                if (!fileUrl) return "unknown";
                const extension = fileUrl.split(".").pop()?.toLowerCase();
                if (
                  ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(
                    extension,
                  )
                ) {
                  return "image";
                } else if (extension === "pdf") {
                  return "pdf";
                } else if (["xlsx", "xls", "csv"].includes(extension)) {
                  return "excel";
                }
                return "unknown";
              };

              const fileType = getFileType(fileUrl);

              return (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "12px",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    background: "#fafafa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f0f0f0";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fafafa";
                  }}
                  onClick={() => {
                    if (fileType === "image") {
                      handleImagePreviewOpen(fileUrl);
                    } else {
                      window.open(fileUrl, "_blank");
                    }
                  }}
                >
                  {fileType === "image" ? (
                    <>
                      <img
                        src={fileUrl}
                        alt={`File ${index + 1}`}
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "4px",
                          marginBottom: "8px",
                        }}
                      />
                      <Typography variant="body2" style={{ fontSize: "12px" }}>
                        Image {index + 1}
                      </Typography>
                    </>
                  ) : fileType === "pdf" ? (
                    <>
                      <div style={{ fontSize: "48px", marginBottom: "8px" }}>
                        📄
                      </div>
                      <Typography variant="body2" style={{ fontSize: "12px" }}>
                        PDF Document
                      </Typography>
                    </>
                  ) : fileType === "excel" ? (
                    <>
                      <div style={{ fontSize: "48px", marginBottom: "8px" }}>
                        📊
                      </div>
                      <Typography variant="body2" style={{ fontSize: "12px" }}>
                        Excel File
                      </Typography>
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: "48px", marginBottom: "8px" }}>
                        📎
                      </div>
                      <Typography variant="body2" style={{ fontSize: "12px" }}>
                        File {index + 1}
                      </Typography>
                    </>
                  )}

                  <Button
                    variant="outlined"
                    size="small"
                    style={{
                      marginTop: "8px",
                      fontSize: "10px",
                      padding: "4px 8px",
                      color: "white",
                      backgroundColor: "#003a6b",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    Open
                  </Button>
                </div>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>
    </Paper>
  );
};

export default CommonTable;
